export const OFFER_ASSET_CLIENT_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferAssetClientUpdated";

export const OFFER_ASSET_CLIENT_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferAssetClientInvalidated";
